import { useIntl } from 'react-intl';

import { Button, Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';

import {
	DialogButton,
	DialogButtons,
	DialogContent,
	DialogMessage,
	DialogOverlay,
	DialogTitle,
} from '../styles';

interface DeleteConfirmDialogProps {
	onConfirm: () => void;
	onCancel: () => void;
}

export default function DeleteConfirmDialog({ onConfirm, onCancel }: DeleteConfirmDialogProps) {
	const { formatMessage } = useIntl();

	return (
		<DialogOverlay>
			<DialogContent>
				<DialogTitle>
					<Text>{formatMessage(messages.logDeleteDialogTitle)}</Text>
				</DialogTitle>
				<DialogMessage>
					<Text>{formatMessage(messages.logDeleteDialogMessage)}</Text>
				</DialogMessage>
				<DialogButtons>
					<DialogButton>
						<Button onPress={onCancel} backgroundColor="accessibleBrandGradient">
							{formatMessage(messages.logDeleteDialogCancel)}
						</Button>
					</DialogButton>
					<DialogButton>
						<Button onPress={onConfirm} backgroundColor="error">
							{formatMessage(messages.logDeleteDialogDelete)}
						</Button>
					</DialogButton>
				</DialogButtons>
			</DialogContent>
		</DialogOverlay>
	);
}
